











// libraries
import { PropType } from 'vue';
// utils
import mixins from '@/utils/mixins';

// mixins
import authorization from '@/mixins/authorization';
import colorable from '@/mixins/colorable';
import snackbar from '@/mixins/snackbar';

// models
import { Quote, QuoteState } from '@/models/quote';

export default mixins(colorable, authorization, snackbar).extend({
  props: {
    quote: Object as PropType<Quote>
  },
  data() {
    return {
      QuoteState,
      loading: false
    };
  },

  computed: {
    componentName(): string {
      switch (this.quote.state) {
        case QuoteState.DRAFT:
          return 'QuotesStatesQuoteDraftStateCard';

        case QuoteState.SUBMITTED:
          return 'QuotesStatesQuoteSubmittedStateCard';

        case QuoteState.APPROVAL_2_PENDING:
          return 'QuotesStatesQuoteApproval2PendingStateCard';

        case QuoteState.APPROVAL_3_PENDING:
          return 'QuotesStatesQuoteApproval3PendingStateCard';

        case QuoteState.APPROVAL_4_PENDING:
          return 'QuotesStatesQuoteApproval4PendingStateCard';

        case QuoteState.IN_REVIEW:
          return 'QuotesStatesQuoteInReviewStateCard';

        case QuoteState.APPROVED:
          return 'QuotesStatesQuoteApprovedStateCard';

        case QuoteState.PREPARE_FOR_CUSTOMER:
          return 'QuotesStatesQuoteCustomerPreparationStateCard';

        case QuoteState.OUT_TO_CUSTOMER:
          return 'QuotesStatesQuoteSendOutStateCard';

        case QuoteState.AWARDED:
          return 'QuotesStatesQuoteAwardedStateCard';

        case QuoteState.LOST:
          return 'QuotesStatesQuoteLostStateCard';

        case QuoteState.ORDER_CREATED:
          return 'QuotesStatesQuoteOrderCreatedStateCard';

        case QuoteState.REVIEWING_DISCOUNTS:
          return 'QuotesStatesQuoteReviewingDiscountsStateCard';

        case QuoteState.REVIEWING_SURCHARGES:
          return 'QuotesStatesQuoteReviewingSurchargesStateCard';

        default:
          return '';
      }
    }
  }
});
